import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookieAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-gray-200 text-sm px-4 py-3">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-center sm:text-left">
          We use cookies to improve your experience and analyze traffic.
          By continuing to use this site, you agree to our{" "}
          <Link
            to="/privacy-policy"
            className="text-blue-400 underline hover:text-blue-300"
          >
            Privacy Policy
          </Link>.
        </p>

        <button
          onClick={acceptCookies}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded transition"
        >
          OK
        </button>
      </div>
    </div>
  );
};
